import React, { PropsWithChildren } from 'react';
import { StackProps } from 'atoms/Layout/Stack/Stack';
import { FrostedOverlayContainer } from './FrostedOverlay.styles';

const FrostedOverlay = ({ children, ...props }: PropsWithChildren<StackProps>): JSX.Element => (
  <FrostedOverlayContainer
    background='alpha-black-dark-20'
    borderRadius='radius-2xl'
    {...props}
  >
    {children}
  </FrostedOverlayContainer>
);

export default FrostedOverlay;
